import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IntroductionToNdcPage } from 'src/app/model/page/group/api-docs/introduction-to-ndc-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-introduction-to-ndc-page',
  templateUrl: './introduction-to-ndc-page.component.html',
  styleUrls: ['./introduction-to-ndc-page.component.scss']
})
export class IntroductionToNdcPageComponent implements OnInit {
  introductionToNdcPage: IntroductionToNdcPage = {} as IntroductionToNdcPage;
  pageName = 'Introduction to NDC';

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'introduction-to-ndc') {
        this.introductionToNdcPage.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentResponse(query).then((resIncludes) => {
      this.mapBanner(resIncludes.includes.Entry);
      this.sharedDataService.addSharedData(this.introductionToNdcPage.banner);
      this.mapPageInfo(resIncludes.items);
      this.mapImage(resIncludes.Asset);
    });
  }

  private mapBanner(introductionToNdcPageEntries: Entry<any>[]) {
    introductionToNdcPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.introductionToNdcPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }
  private mapImage(assets: Entry<any>[]) {
    // console.log('video', assets);
    if (assets) {
      const asset = assets.filter((asset) => asset.fields['title'] === this.pageName)[2];
      const givenImage:any= asset.fields;
      this.introductionToNdcPage.image =givenImage.file.url;
    }
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.introductionToNdcPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.introductionToNdcPage.banner.url = entry.fields?.url;
      this.introductionToNdcPage.banner.editorEmail = editorDetails?.pop();
      this.introductionToNdcPage.banner.editorShortName = editorDetails?.pop();
      this.introductionToNdcPage.banner.editorFullName = editorDetails?.pop();
      this.introductionToNdcPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
